import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import Loading from 'components/Loading/Loading';
import moment from 'moment';
import { connect } from 'react-redux';
import { fetchPendingBookings } from 'actions/bookingActions';
import { cancelBooking } from 'actions/reservationActions';
import { openModal } from 'actions/modalActions';

import TeacherPendingReservation from '../TeacherPendingReservation';

import './style.css';

class TeacherPendingReservationList extends Component {
  componentDidMount() {
    this.props.fetchPendingBookings();
  }

  handleConfirmReservation = (reservation) => {
    const { openModal, fetchPendingBookings } = this.props;
    openModal('teacher-lesson-confirmation-modal', {
      lessonId: reservation.id,
      reloadBookings: () => fetchPendingBookings()
    });
  }

  renderReservations(groupedReservations) {
    const today = moment().format('MM/DD/YYYY');
    let reservationList = [];
    const { source } = this.props;

    for (const dateKey in groupedReservations) {
      const dateText =
        dateKey === today ?
          `${moment(dateKey, 'MM/DD/YYYY').format('MMMM D, YYYY')} (Today)` :
          moment(dateKey, 'MM/DD/YYYY').format('MMMM D, YYYY (ddd)');
      reservationList.push(
        <p key={`title-${dateKey}`} className="teacher-pending-reservation-list__title">
          {dateText}
        </p>
      );

      for (const reservation of groupedReservations[dateKey]) {
        reservationList.push(
          <TeacherPendingReservation
            key={reservation.id}
            reservation={reservation}
            source={source}
            onConfirm={this.handleConfirmReservation}
          />
        );
      }
    }
    return reservationList;
  }

  render() {
    const reservations = Object.values(this.props.reservations || []);
    const { reservationsStatus } = this.props;
    const groupedReservations = _.groupBy(reservations, (r) => moment(r.startTime).format('MM/DD/YYYY'));

    if (reservations.length === 0) {
      return null;
    }

    return (
      <div className="teacher-pending-reservation-list">
        {reservationsStatus !== 'SUCCESS' ? (
          <Loading />
        ) : (
          <Fragment>
            <p className="teacher-pending-reservation-list__title text-primary">
              {`${String.fromCharCode(9888)} ${_.size(reservations)} unconfirmed lesson(s)`}
            </p>
            <p className="teacher-pending-reservation-list__title text-primary">
              Please confirm these lessons in order for you to be paid.
            </p>
            {this.renderReservations(groupedReservations)}
          </Fragment>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    reservations: state.bookings.pendingBookings,
    reservationsStatus: state.bookings.pendingBookingsStatus
  };
}

export default connect(
  mapStateToProps,
  {
    openModal,
    fetchPendingBookings,
    cancelBooking
  }
)(TeacherPendingReservationList);



// WEBPACK FOOTER //
// ./src/components/TeacherPendingReservationList/index.js